import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "introduction",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#introduction",
        "aria-label": "introduction permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Introduction`}</h1>
    <p>{`eaterpad is a nutrition tracker available on iOS and Android. It is designed to be easy to use and customize, with comprehensive
nutrient coverage for 80+ nutrients. It is also designed
to allow for easy analysis of your overall nutrient intake, allowing for views of your consumption on an overall basis,
on a per nutrient basis, and on varying timescales.`}</p>
    <h2 {...{
      "id": "eaterpad-features",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#eaterpad-features",
        "aria-label": "eaterpad features permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`eaterpad Features`}</h2>
    <ul>
      <li parentName="ul">{`⚛️ Log Foods`}</li>
      <li parentName="ul">{`📝 Track intake by meal and day`}</li>
      <li parentName="ul">{`🧑‍🍳 Create recipes and custom food`}</li>
      <li parentName="ul">{`📱 Customize nutrients and targets`}</li>
      <li parentName="ul">{`🍎 Access to 80+ nutrients`}</li>
      <li parentName="ul">{`🥇 Add photos of meals`}</li>
      <li parentName="ul">{`📈 Long-term charts`}</li>
      <li parentName="ul">{`📄 Export daily totals`}</li>
      <li parentName="ul">{`⚡️ View complete log history for foods`}</li>
      <li parentName="ul">{`🌿 Order foods by nutrient values`}</li>
      <li parentName="ul">{`✨ Aggregated consumption history`}</li>
      <li parentName="ul">{`and much more 🔥`}</li>
    </ul>
    <h2 {...{
      "id": "using-help-documentation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#using-help-documentation",
        "aria-label": "using help documentation permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Using help documentation`}</h2>
    <ul>
      <li parentName="ul">{`Search directly for a topic using the search bar`}</li>
      <li parentName="ul">{`Tap the menu button in the top right corner to open the sidebar for a table of contents`}</li>
      <li parentName="ul">{`Tap "Get started!" to continue`}</li>
    </ul>
    <br />
    <p><a parentName="p" {...{
        "href": "/help/getting-started"
      }}><div style={{
          "alignItems": "center",
          "display": "flex"
        }}>{`Get started!`}<svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="25px" width="25px" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path></svg></div></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      